import { Component, Input } from '@angular/core';
import { Author } from '../author';
import { AuthorsService } from '../authors.service';
import { FormBuilder, FormControl } from '@angular/forms';
import { authorValidator } from '../new-author/role-selected.directive';

@Component({
  selector: 'app-selected-author',
  templateUrl: './selected-author.component.html',
  styleUrls: ['./selected-author.component.css']
})
export class SelectedAuthorComponent {

  @Input() selectedAuthor?: Author

  constructor(private formBuilder: FormBuilder, private authorService: AuthorsService) { }

  ngOnChanges() {
    this.resetForm()
  }

  editingAuthor = false

  //FIXME: - upload file
  newFile: File | undefined
  newFileName: string | undefined

  authorForm = this.formBuilder.group({
    firstName: [''],
    lastName: [''],
    bio: [''],
  }, { validators: authorValidator })

  firstNameControl = <FormControl>this.authorForm.get('firstName');
  lastNameControl = <FormControl>this.authorForm.get('lastName');
  bioControl = <FormControl>this.authorForm.get('bio');


  editAuthor() {
    this.editingAuthor = true
    this.authorService.keepFocus = true
  }

  removeAuthor() {
    this.authorService.deleteAuthor(this.selectedAuthor!!)
  }

  cancelUserEditing() {
    this.resetForm()
    this.editingAuthor = false
    this.authorService.keepFocus = false
  }

  resetForm() {
    this.firstNameControl.setValue(this.selectedAuthor!!.firstName)
    this.lastNameControl.setValue(this.selectedAuthor!!.lastName)
    this.bioControl.setValue(this.selectedAuthor!!.bio)
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      if (file.type == "image/png" || file.type == "image/jpeg") {
        this.newFile = file
        this.newFileName = file.name
      } else {
        alert(`Error: Invalid File Type - ${file.name}`)
        return
      }
    }
  }

  removeFile() {
    this.newFile = undefined
    this.newFileName = undefined
  }

  cancelClicked() {
    this.authorService.addUserCancelled()
    this.editingAuthor = false
  }

  submitAuthorEdits() {
    const editedAuthor = this.createAuthorFromForm()
    if (JSON.stringify(editedAuthor) === JSON.stringify(this.selectedAuthor) && this.newFile == undefined) {
      this.cancelUserEditing()
      alert("No changes made")
      return
    }
    this.authorService.updateAuthor(editedAuthor, this.newFile)
  }

  createAuthorFromForm(): Author {
    const uid = this.selectedAuthor?.uid!!
    const first = this.authorForm.value.firstName!!
    const last = this.authorForm.value.lastName!!
    const bio = this.authorForm.value.bio!!
    return ({uid: uid, firstName: first, lastName: last, bio: bio}) as Author
  }
}